// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SideNav a {\n  text-decoration: none;\n}\n\n.SideNav--item a:hover {\n  background-color: #e5e5e5;\n}\n", ""]);
// Exports
module.exports = exports;
